module.exports = __webpack_public_path__ + "img/2.2a686250.png";